// extracted by mini-css-extract-plugin
module.exports = {"Month":"Month__22IAV"};